import {NgModule} from '@angular/core';
import {ARTICLES} from '@infrastructure/http/article/articles';
import {HttpArticlesService} from '@infrastructure/http/article/http-articles.service';
import {COLOR_SETS} from '@infrastructure/http/color-set/color-sets';
import {HttpColorSetsService} from '@infrastructure/http/color-set/http-color-sets.service';
import {COLORS} from '@infrastructure/http/color/colors';
import {HttpColorsService} from '@infrastructure/http/color/http-colors.service';
import {COLORED_YARN_SETS} from '@infrastructure/http/colored-yarn-set/colored-yarn-sets';
import {HttpColoredYarnSetsService} from '@infrastructure/http/colored-yarn-set/http-colored-yarn-sets.service';
import {FINISHING_TEMPLATES} from '@infrastructure/http/finishing-template/finishing-templates';
import {HttpFinishingTemplatesService} from '@infrastructure/http/finishing-template/http-finishing-templates.service';
import {FINISHINGS} from '@infrastructure/http/finishing/finishings';
import {HttpFinishingsService} from '@infrastructure/http/finishing/http-finishings.service';
import {HttpMachineQualitiesService} from '@infrastructure/http/machine-quality/http-machine-qualities.service';
import {MACHINE_QUALITIES} from '@infrastructure/http/machine-quality/machine-qualities';
import {REALTIME_YARN_CONSUMPTION} from '@infrastructure/signalr/yarn-consumption/realtime-yarn-consumption';
import {SignalrYarnConsumptionService} from '@infrastructure/signalr/yarn-consumption/signalr-yarn-consumption.service';
import {OverviewListFinishingAndFinishingTemplateService} from '@presentation/components/finishing-and-finishing-template/overview/overview-list-finishing-and-finishing-template.service';
import {DrawingLibrarySharedModule} from '@presentation/pages/texedit/drawing-library/drawing-library-shared.module';
import {AddArticlePageComponent} from '@presentation/pages/texfab/article/add/add-article-page.component';
import {SelectDesignComponent} from '@presentation/pages/texfab/article/add/select-design/select-design.component';
import {articleDataRouting} from '@presentation/pages/texfab/article/article.routing';
import {ArticleOverviewPageComponent} from '@presentation/pages/texfab/article/overview/article-overview-page.component';
import {SharedModule} from '@shared/shared.module';
import {CanShowErrorForFormControlModule} from '@vdw/angular-component-library';

@NgModule({
  imports: [SharedModule, articleDataRouting, DrawingLibrarySharedModule, CanShowErrorForFormControlModule],
  providers: [
    {provide: ARTICLES, useClass: HttpArticlesService},
    {provide: COLORED_YARN_SETS, useClass: HttpColoredYarnSetsService},
    {provide: FINISHING_TEMPLATES, useClass: HttpFinishingTemplatesService},
    {provide: MACHINE_QUALITIES, useClass: HttpMachineQualitiesService},
    {provide: COLOR_SETS, useClass: HttpColorSetsService},
    {provide: COLORS, useClass: HttpColorsService},
    {provide: FINISHINGS, useClass: HttpFinishingsService},
    {provide: REALTIME_YARN_CONSUMPTION, useClass: SignalrYarnConsumptionService},
    OverviewListFinishingAndFinishingTemplateService
  ],
  declarations: [ArticleOverviewPageComponent, AddArticlePageComponent, SelectDesignComponent]
})
export class ArticleModule {}
